module.exports = __webpack_public_path__ + "img/login-form-img.adba60d1.svg";